<template>
    <section class="error">
        <div class="error__container container">
            <h1>{{ error?.statusCode || $t('pageErrorTitle') }}</h1>
            <p v-if="error?.statusCode === 404">{{ $t('pageErrorDescription') }}</p>
            <p v-if="error?.statusCode != 404">{{ $t('globalMessageSomethingWentWrong') }}</p>
            <MyActionBtn
                :btnText="$t('globalTextAttributHomePage')"
                icon="arrowRightIcon"
                btnType="submit"
                :isFreeWidth="true"
                :urlPath="`/`"
            />
        </div>
    </section>
</template>

<script>
export default {
    props: ['error'],
    components: {
        MyActionBtn: () => import('@/themes/novaporta/components/ui/MyActionBtn')
    },
};
</script>

<style scoped lang="scss">
.error {
    display: flex;
    padding: 120px;
    color: var(--surface-dark-ground);
    
    @media (max-width: 1024px) { padding: 80px }
    @media (max-width: 768px) { padding: 24px }

    &__container {
        width: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h1 {
            font-size: 110px;
            font-weight: 700;
            line-height: 1;

            margin-bottom: 30px;
        }

        p {
            font-size: 16px;
            font-weight: 500;
            line-height: 128%;

            max-width: 500px;
            text-align: center;
            margin-bottom: 24px;
        }
    }
}
</style>
